<template>
  <div>
    <img class="bgone" src="../../src/assets/bg.jpg" />

    <!--
    <div class="table">
      <Form ref="formUserPwd" :model="formUserPwd" :rules="ruleInline" inline>
        <FormItem class="user" prop="username">
          <Input v-model="formUserPwd.username" size="large" style="width: 360px;" prefix="icon iconfont icon-icon_account" type="text" placeholder="请输入用户名" @keyup.enter="isLogin" />
        </FormItem>
        <FormItem class="password" prop="password">
          <Input v-model="formUserPwd.password" size="large" style="width: 360px;"  prefix="icon iconfont icon-mima" type="password" placeholder="请输入密码" @keyup.enter="isLogin" />
        </FormItem>
        <FormItem>
          <Button class="btn" type="primary" :disabled="butSubmit.isDisable" :icon="butSubmit.icon" @click="handleSubmit('formUserPwd')">{{
            butSubmit.text }}</Button>
        </FormItem>
      </Form>
    </div> -->
    <i class="icon iconfont icon-mima" />
    <div class="table">
      <div class="pic">
        <img src="../../src/assets/huanbao.png" />
        <img src="../../src/assets/xinwu.png" />
      </div>
      <div class="wel">无锡市新吴生态环境局污染物排放过程监控及分析系统</div>
      <div class="wel1">
        Wuxi Xinwu Ecological Environmental Protection Bureau Pollutant Discharge Process Monitoring and Analysis System
      </div>
      <div class="user">
        <div id="yonghu" style="">
          <i class="icon iconfont icon-icon_account" />
        </div>
        <input v-model="username" type="text" name="" placeholder="请输入用户名" @keyup.enter="isLogin" />
      </div>
      <div class="password">
        <div id="yonghu"><i class="icon iconfont icon-mima" /></div>
        <input v-model="password" type="password" name="密码" placeholder="请输入密码" @keyup.enter="isLogin" />
      </div>
      <Button class="btn" type="primary" :disabled="butSubmit.isDisable" :icon="butSubmit.icon" @click="isLogin">{{
        butSubmit.text
      }}</Button>
      <div class="copybox">
        <div class="linkdiv">
          <a href="https://beian.miit.gov.cn" target="_blank">ICP:苏ICP备2026012207号-6</a>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021402004950"
            ><img src="@/assets/pliceicon.png" style="float: left" />
            <p style="float: left; height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: #939393">
              苏公网安备 32021402004950号
            </p></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      username: '',
      password: '',
      butSubmit: {
        isDisable: false,
        text: '登录',
        icon: 'icon iconfont icon-denglu',
      },
    };
  },
  methods: {
    /**
     * 登录按钮验证事件
     */
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (!valid) {
          // console.log('验证失败！');
          return false;
        }

        // 验证成功 禁用登录按钮

        // 调用登录事件
        this.isLogin();
      });
    },
    /**
     * 登录事件
     */
    isLogin() {
      // 判断用户名和密码不为空
      if (this.username === '') {
        this.$Message.error(`请输入用户名！`);
        return false;
      } else if (this.password === '') {
        this.$Message.error(`请输入密码！`);
        return false;
      }
      // 禁用按钮
      this.butSubmit = {
        isDisable: true,
        text: '登录中...',
        icon: 'ios-loading',
      };

      // 开始请求接口
      const api = this.ApiUrl + 'user/login';
      const data = {
        account: this.username,
        password: this.password,
        qhtype: 0,
      };
      this.$http.post(api, data).then(
        res => {
          // console.log(res.data);
          if (res.data.extend.news === 0) {
            // 登录成功
            if (!res.data.extend.token) {
              this.$Message.error(`登录响应缺少身份凭据，请联系管理员！`);
              this.butSubmit = {
                isDisable: false,
                text: '登录',
                icon: 'icon iconfont icon-denglu',
              };
              return;
            }
            this.$Message.success(`登录中成功！跳转中...`);
            // 存储用户信息到localStorage
            const AC_USER_INFO = {
              type: res.data.extend.type,
              user_id: res.data.extend.user_id,
              unit_name: res.data.extend.unit_name,
            };
            localStorage.setItem('AC_USER_INFO', JSON.stringify(AC_USER_INFO));
            sessionStorage.setItem('AC_ACCESS_TOKEN', res.data.extend.token);
            // 定时跳转
            setTimeout(() => {
              this.$router.push('home');
            }, 1500);
          } else {
            // 错误
            this.$Message.warning(res.data.extend.message);
            this.butSubmit = {
              isDisable: false,
              text: '登录',
              icon: 'icon iconfont icon-denglu',
            };
          }
        },
        res => {
          // 服务器出错
          this.$error.loading(res.data.msg);
          this.butSubmit = {
            isDisable: false,
            text: '登录',
            icon: 'icon iconfont icon-denglu',
          };
        },
      );
    },
  },
};
</script>
<style scoped>
* {
  font-family: '微软雅黑';
  font-size: 16px;
  border: 0;
  padding: 0;
  margin: 0;
  color: #666;

  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

.bgone {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
}

.pic {
  width: 492px;
  height: auto;
  position: absolute;
  top: 50%;
  left: 0;
  bottom: 0;
  margin: auto;
  margin-top: -4.6875rem;
  z-index: 99;
}

.pic img {
  width: 152px;
  height: 140px;
  margin: 0 20px 0 60px;
}

.table {
  background-color: #ffffff;
  width: 960px;
  height: 465px;
  border-radius: 16px;
  position: absolute;
  top: 10%;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
}

.password {
  position: absolute;
  top: 12.8rem;
  right: 4rem;
  display: flex;
}

.btn {
  position: absolute;
  top: 18.5rem;
  right: 3.9rem;
  border: none;
  color: #fff;
  width: 373px;
  text-align: center;
  background-color: #1592ef;
  text-indent: 0rem;
  border-radius: 10px;
  text-shadow: 2px 2px 1px rgba(0, 0, 0, 0.2);
  box-shadow: 2px 2px 1px rgba(0, 0, 0, 0.2);
  font-size: 20px;
  height: 50px;
}

.wel {
  width: 960px;
  height: 35px;
  color: #fff;
  font-size: 36px;
  position: absolute;
  top: -8rem;
  text-align: center;
}

.wel1 {
  width: 960px;
  height: 35px;
  color: #fff;
  font-size: 16px;
  position: absolute;
  top: -4rem;
  text-align: center;
}

input {
  height: 55px;
  width: 373px;
  text-indent: 55px;
  outline: none;
  background: #eef6fd;
}

.password input {
  border: 0;
}

.user {
  position: absolute;
  top: 7.8rem;
  right: 4rem;
  display: flex;
}

#yonghu i {
  color: #3e8cc4;
  font-size: 28px;
  position: absolute;
  left: 12px;
  top: 6px;
  font-style: normal;
}

.icp {
  color: #909090;
}
.copybox {
  position: absolute;
  bottom: 20px;
  width: 100%;
  text-align: center;
  position: inherit;
  z-index: 999;
}
.linkdiv {
  margin: 0 auto;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  color: #939393;
}

.linkdiv > a {
  color: #939393;
  cursor: pointer;
}
.linkdiv > a:first-child {
  margin-right: 20px;
}
</style>
